/**
 * Bandeau « prix figés ».
 *
 * Un flux de cotations coupé ne produit aucune erreur : le compte répond, le
 * bandeau d'état affiche « courtier connecté », et seuls les prix cessent de
 * bouger. C'est ce qui est arrivé en production, pendant des jours, sans que
 * rien ne le signale. Une minute sans aucune cotation sur les vingt-huit
 * paires ne se voit pas en séance : soit le marché est fermé, soit le flux est
 * mort — et dans les deux cas le prix à l'écran n'est plus celui du marché.
 */
export function StaleQuotes({ age }: { age: number | null }) {
  if (age === null || age < 60) return null
  return (
    <div className="mx-3 mt-2 rounded-md border border-warn/40 bg-warn/10 px-2.5 py-1.5 text-[11px] leading-snug text-warn">
      <span className="font-semibold">Prix figés</span> — aucune cotation depuis{' '}
      <span className="num">{formatAge(age)}</span>. Marché fermé, ou flux interrompu : le
      prix affiché n'est plus celui du marché.
    </div>
  )
}

/** « 12 min », « 3 h », « 2 j » : l'ordre de grandeur, pas la seconde près. */
function formatAge(seconds: number): string {
  if (seconds < 3600) return `${Math.max(1, Math.floor(seconds / 60))} min`
  if (seconds < 48 * 3600) return `${Math.floor(seconds / 3600)} h`
  return `${Math.floor(seconds / 86400)} j`
}
